import React from 'react';

import { SvgProps } from '../enums';

export const FlagVC: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_55163"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_55163)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0H12V12H4V0Z"
        fill="#FFDC17"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0H16V12H12V0Z"
        fill="#5FBF2B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H4V12H0V0Z"
        fill="#2E42A5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M9.86319 2.5L8.34314 4.73144L9.86319 6.88395L11.3833 4.73144L9.86319 2.5ZM6.13861 2.53942L4.5 4.73144L6.02006 6.84461L7.54011 4.73144L6.13861 2.53942ZM6.42157 7.1944L8.06018 5.00239L9.46168 7.1944L8.06018 9.45057L6.42157 7.1944Z"
        fill="#5FBF2B"
      />
    </g>
  </svg>
);
